import {
	useSoundStore,
	useWelcomeStore,
} from '../../../../../store/sceneStore';

export const useUpdateGreetingSound = () => {
	const setWelcome = useWelcomeStore((s) => s.setState);
	const setSound = useSoundStore((s) => s.setState);

	const onUpdateGreetingSound = () => {
		setWelcome((prev) => ({ ...prev, greeting: true }));
		setSound({
			method: 'stop&play',
			sound_list: ['greeting'],
			end_event: {
				greeting: () => {
					setWelcome((prev) => ({ ...prev, greeting: false }));
					setSound((prev) => {
						return { ...prev, end_event: {} };
					});
				},
			},
		});
	};

	return onUpdateGreetingSound;
};
